import { render } from "./ResilientAvatarImage.vue?vue&type=template&id=16c10014&scoped=true"
import script from "./ResilientAvatarImage.vue?vue&type=script&lang=js"
export * from "./ResilientAvatarImage.vue?vue&type=script&lang=js"

import "./ResilientAvatarImage.vue?vue&type=style&index=0&id=16c10014&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c10014"]])

export default __exports__